import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var FooterCss = i`
  :host {
    font-family: var(--isceco-font);
  }

  footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: var(--isceco-space-200) 90px;
    background-color: var(--isceco-color-background);
    border-top: 1px solid var(--isceco-color-grey-300);
    color: var(--isceco-color-black-500);
  }

  @media (max-width: 991.98px) {
    footer {
      font-size: 0.75rem;
      padding: var(--isceco-space-200) 20px;
    }
  }
`;
export { FooterCss as default };
